<template>
    <GroupedSelectionDialog
        :value="value"
        :groups="groups"
        :selection="selection"
        :loading="loading"
        :error="error"
        title="Специализация"
        search-label="Поиск специализации"
        empty-label="Профессии не найдены"
        close-label="Закрыть выбор профессий"
        id-prefix="profession"
        @input="$emit('input', $event)"
        @save="save"
        @retry="$emit('retry')"
    />
</template>

<script>
import GroupedSelectionDialog from './GroupedSelectionDialog.vue'

export default {
    name: 'ProfessionDialog',
    components: { GroupedSelectionDialog },
    props: {
        value: Boolean,
        items: { type: Array, default: () => [] },
        selection: { type: Array, default: () => [] },
        loading: Boolean,
        error: { type: String, default: '' },
    },
    computed: {
        groups () {
            const groups = this.items.filter(item => item.parent_id === null).map(item => ({
                id: item.id,
                name: item.name.trim(),
                children: [],
            }))
            const indexed = new Map(groups.map(group => [group.id, group]))
            this.items.filter(item => item.parent_id !== null).forEach(item => {
                const parent = indexed.get(item.parent_id)
                if (parent) parent.children.push({ id: item.id, name: item.name.trim() })
            })
            groups.forEach(group => group.children.sort((a, b) => a.name.localeCompare(b.name, 'ru')))
            return groups.sort((a, b) => a.name.localeCompare(b.name, 'ru'))
        },
    },
    methods: {
        save (selection) {
            // Search expects individual profession IDs even when a whole category is selected.
            const selected = new Set(selection)
            this.groups.forEach(group => {
                if (selected.has(group.id)) {
                    group.children.forEach(child => selected.add(child.id))
                }
            })
            this.$emit('save', [...selected])
        },
    },
}
</script>
